import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AiLoginPage = _resolveComponent("AiLoginPage")!

  return (_openBlock(), _createBlock(_component_AiLoginPage, {
    "authorization-code": _ctx.authorizationCode,
    "onUpdate:authorizationCode": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authorizationCode) = $event)),
    progress: _ctx.displayProgress,
    "progress-caption": _ctx.progressCaption,
    "verification-state": _ctx.verificationState,
    "verification-title": _ctx.verificationTitle,
    "verification-detail": _ctx.verificationDetail,
    "verification-state-label": _ctx.verificationStateLabel,
    "button-label": _ctx.primaryButtonLabel,
    "button-hint": _ctx.primaryButtonHint,
    "left-modules": _ctx.leftModules,
    "right-modules": _ctx.rightModules,
    "is-submitting": _ctx.isCheckingPassword,
    "is-leaving": _ctx.isLeaving,
    "button-ripple-id": _ctx.buttonRippleId,
    onSubmit: _ctx.handleLogin
  }, null, 8, ["authorization-code", "progress", "progress-caption", "verification-state", "verification-title", "verification-detail", "verification-state-label", "button-label", "button-hint", "left-modules", "right-modules", "is-submitting", "is-leaving", "button-ripple-id", "onSubmit"]))
}